import React from 'react';
import { ShareVisibility } from '../../share/api';

// Trip sharing v1: quiet outline pill marking a SHARED trip (and its
// journeys) for the owner. Rendered only when sharing is on — the default
// "Only me" state stays untagged so the UI carries no badge noise. Same
// shape family as MainTag; outline (not filled) so MAIN keeps the visual
// priority when both show.

const LABELS: Record<Exclude<ShareVisibility, 'private'>, string> = {
  link: 'Shared',
  password: 'Shared · password',
};

const ShareTag: React.FC<{ visibility: ShareVisibility }> = ({ visibility }) => {
  if (visibility === 'private') return null;
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
        padding: '2px 8px',
        borderRadius: 999,
        fontSize: 11,
        fontWeight: 700,
        letterSpacing: 0.4,
        color: '#157a55',
        background: '#e7f1ec',
        border: '1px solid rgba(21,122,85,0.35)',
        textTransform: 'uppercase',
        whiteSpace: 'nowrap',
      }}
    >
      <svg width="11" height="11" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
          d="M12 3v12M12 3l-4 4M12 3l4 4M5 13v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6"
          stroke="currentColor"
          strokeWidth="2.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      {LABELS[visibility]}
    </span>
  );
};

export default ShareTag;
